export default __webpack_public_path__ + "static/media/about-us-img.f13715ba.webp";